import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { SALES_CHANNELS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const initialState = {
	syncInfo: JSON.parse(localStorage.getItem('sallaSyncInfo') || '[]'),
	lastError: JSON.parse(localStorage.getItem('sallaLastError') || '[]'),
	sallaStores: JSON.parse(localStorage.getItem('sallaStores') || '[]'),
	sallaUpdateInfo: JSON.parse(localStorage.getItem('sallaUpdateInfo') || '[]')
};

export const fetchSallaStores = createAsyncThunk(
	'salla/fetchSallaStores',
	async ({ forceSync = true }, { getState }) => {
		const axiosPrivate = useAxiosPrivate();
		if (!forceSync) {
			return getState().salla.sallaStores;
		}

		try {
			const response = await axiosPrivate.get(SALES_CHANNELS.GET_SALLA_STORE_INFO_DESKTOP, {});
			if (response.status === 200) {
				return response.data?.storeInfos;
			}
		} catch (error) {
			AppLogger.error(error);
			return JSON.parse(localStorage.getItem('sallaStores') || '[]');
		}
	}
);

export const setSallaStores = createAsyncThunk('salla/setSallaStores', async (payload, { getState }) => {
	const { salla } = getState();
	const axiosPrivate = useAxiosPrivate();

	const updatedSallaStores = [...salla.sallaStores.filter((item) => item.id !== payload.id), payload];

	await axiosPrivate.post(SALES_CHANNELS.SET_SALLA_STORE_INFO_DESKTOP, {
		storeInfos: updatedSallaStores
	});
	return updatedSallaStores;
});

const salla = createSlice({
	name: 'salla',
	initialState,
	reducers: {
		setSyncInfo: (state, action) => {
			state.syncInfo = [
				...state.syncInfo.filter((error) => error?.salesChannelId !== action.payload?.salesChannelId),
				action.payload
			];
			state.lastError = state.lastError.filter(
				(error) => error?.salesChannelId !== action.payload?.salesChannelId
			);
			window.localStorage.setItem('sallaSyncInfo', JSON.stringify(state.lastError));
		},
		setLastError: (state, action) => {
			state.lastError = [
				...state.lastError.filter((error) => error?.salesChannelId !== action.payload?.salesChannelId),
				action.payload
			];
			window.localStorage.setItem('sallaLastError', JSON.stringify(state.lastError));
		},
		setSallaUpdateInfo: (state, action) => {
			const { merchantId } = action.payload;
			state.sallaUpdateInfo = [
				...state.sallaUpdateInfo.filter((item) => item.merchantId !== merchantId),
				action.payload
			];
			window.localStorage.setItem('sallaUpdateInfo', JSON.stringify(state.sallaUpdateInfo));
		}
	},
	extraReducers: (builder) => {
		builder.addCase(setSallaStores.fulfilled, (state, { payload }) => {
			state.sallaStores = payload;
		});
		builder.addCase(setSallaStores.rejected, (state, { payload }) => {
			state.sallaStores = payload;
		});
		builder.addCase(fetchSallaStores.fulfilled, (state, { payload }) => ({ ...state, sallaStores: payload }));
	}
});
export const { setSyncInfo, setLastError, setSallaUpdateInfo, updateSallaUpdateInfo } = salla.actions;

export default salla.reducer;
